export default __webpack_public_path__ + "static/media/prato-executivo.5fe9b9c6.jpg";